
import { detect } from 'detect-browser'
import isRightVerion from './compareVersion'
import defaultConfig from './default-config'

const svg = `<img class="question" alt="" src="data:image/svg+xml;base64,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" />`;
const html = function (hintText, closeText, downloadText) {
    return `
   <div class="browser-hint-dialog">
        <p class="content">${svg}${hintText}</p>
       <div class="buttons">
       <button class="button bh-cancel">${closeText}</button>
       <button class="button bh-confirm">${downloadText}</button>
</div>
</div>
`
};

const css = `
    .browser-hint-dialog-wrapper {
        margin: 0; padding: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: baseIndex;
        font-family: "Segoe UI", Roboto, "Helvetica Neue", "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", sans-serif
    }
    .browser-hint-dialog {
        position: absolute;
        width: 450px;
        background: white;
        left: 50%;
        top: 35%;
        transform: translate(-50%, -50%);
        border-radius: 2px;
        padding: 32px 32px 24px 32px;
    }
    .browser-hint-dialog .buttons{
        display: flex;
        justify-content: flex-end;
    }
    .browser-hint-dialog .content {
        display: flex;
        align-items: flex-start;
        line-height: 26px;
        margin: 1em 0;
    }
    .browser-hint-dialog .question {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        margin-top: 3px;
    }
    .browser-hint-dialog .button {
        padding: 0 16px;
        min-width: 60px;
        height: 32px;
        border-color: transparent;
        background: #3c8cff;
        color: white;
        outline: none;
        cursor: pointer;
        border-radius: 2px;
        font-size: 14px;
    }

    .browser-hint-dialog .button.bh-cancel {
        border: 1px solid #cccccc;
        background: white;
        color: #333333;
        margin-right: 12px;
    }

`;

(function(){

    const textMap = {
        close: {
            zh: '关闭',
            en: 'Close',
            ja: '閉じる'
        },
        download: {
            zh: '去下载',
            en: 'Download',
            ja: 'ダウンロード'
        }
    }

    const userConfig = window.runtime_browser_config;
    const config = defaultConfig;

    if (userConfig.hintText) {
        config.hintText = Object.assign(defaultConfig.hintText, userConfig.hintText)
    }

    if (userConfig && Array.isArray(userConfig.browserList)) {
        config.browserList = userConfig.browserList;
    }

    const isObject = (obj)=>{
        return Object.prototype.toString.call(obj)==='[object Object]'
    }

    if(userConfig && isObject(userConfig.browserVersionMap)) {
        config.browserVersionMap = userConfig.browserVersionMap;
    }

    if (userConfig.language !== undefined) {
        config.language = userConfig.language;
    }

    if (userConfig.remindInterval !== undefined) {
        config.remindInterval = userConfig.remindInterval;
    }

    if (userConfig.baseIndex !== undefined) {
        config.baseIndex = userConfig.baseIndex;
    }

    if (userConfig.ignoreMobile !== undefined) {
      config.ignoreMobile = userConfig.ignoreMobile
    }

    const browser = detect();

    if (!browser) return;

    if (config.ignoreMobile) {
      const mobileList = ['iOS', 'Android OS','BlackBerry OS','Windows Mobile'];
      if (mobileList.includes(browser.os)) {
        return;
      }
    }

    if (config.browserList.indexOf('chrome') > -1) {
        config.browserList.push('edge-chromium')
    }

    // 留一个空方法，防止业务方调用报错
    window.runtime_browser_set_language = function () {}

    const configVersion = config.browserVersionMap[browser.name];

    if (config.browserList.indexOf(browser.name) > -1) {
        if (configVersion) {
            if(isRightVerion(browser.version,configVersion)){
                return;
            }
        }else{
            return;
        }
    }

    const LS_KEY = 'browser-hint-config';

    const configStr = localStorage.getItem(LS_KEY);

    if (configStr) {
        try {
            const config = JSON.parse(configStr);
            if (config.remindInterval < 0) {
                return;
            }
            if (config.leftTimes > 1) {
                config.leftTimes --;
                localStorage.setItem(LS_KEY, JSON.stringify(config));
                return;
            }
        } catch (e) {

        }
    }

    const dialogDom = document.createElement('div');
    dialogDom.setAttribute('class', 'browser-hint-dialog-wrapper');
    dialogDom.innerHTML = html(
        config.hintText[config.language],
        textMap.close[config.language], textMap.download[config.language]);
    const cssDom = document.createElement('style');
    cssDom.innerHTML = css.replace('baseIndex', config.baseIndex + 1000);

    dialogDom.addEventListener('click', event => {
        const classList = event.target.getAttribute('class');
        if (classList && (classList.indexOf('bh-confirm') > -1 || classList.indexOf('bh-cancel') > -1)) {
            if (classList.indexOf('bh-confirm') > -1 ) {
                window.open('https://www.google.com/chrome/')
            } else if (classList.indexOf('bh-cancel') > -1 ) {
                dialogDom.style.display = 'none';
            }
            localStorage.setItem(LS_KEY, JSON.stringify({leftTimes: config.remindInterval}));
        }
    });

    window.runtime_browser_set_language = lang => {
        config.language = lang;
        dialogDom.innerHTML = html(
            config.hintText[config.language],
            textMap.close[config.language], textMap.download[config.language]);
    }

    document.head.appendChild(cssDom);
    document.body.appendChild(dialogDom)

})();
